var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3727 0 0 5.3727 0 12C0 18.6273 5.3727 24 12 24C18.6273 24 24 18.6273 24 12C24 5.3727 18.6273 0 12 0ZM5.27376 5.27376H18.7263V7.655H17.2619V8.965H18.7263V11.345H17.2619V12.655H18.7263V15.035H17.2619V16.345H18.7263V18.7269H5.27376V5.27376ZM11.2675 7.62312C10.1937 7.62312 9.32374 8.49428 9.32374 9.56812C9.32374 10.3291 9.76058 10.9875 10.3975 11.3069L7.90874 12.7969H7.87812V14.8988H14.6569V12.7969H14.6263L12.1375 11.3069C12.7744 10.9875 13.2113 10.3291 13.2113 9.56812C13.2112 8.49428 12.3413 7.62312 11.2675 7.62312Z",
    fill: "#17282F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.b311ce8a05ecc0bcfcf7366c4603165c.svg";
export { ForwardRef as ReactComponent };